<template>

  <div class="card card-default shadow">
    <!-- <div class="card-header">
      <div class="card-title">
        <button type="button" v-on:click="Print()" class="btn bg-custom btn-sm"> +print</button>
      </div>
    </div> -->
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>Subject</label>
            <select v-model="teacherID" class="form-control">
              <option value="0">All</option>
              <option v-for="item in courses" :value="item.TeacherCourseAllotmentID">{{item.CourseTitle}} - {{item.ClassName}}</option>
            </select>
            <!--<input class="form-control" disabled v-model="course.CourseTitle + ' - ' + course.ClassName" />-->
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group mt-2">
            <div class="table-responsive text-left">
              <table class="table table-bordered table-sm " id="tbl">
                <thead class="bg-custom">
                  <tr>
                    <th style="width: 10px">Sr.</th>
                    <th style="width: 30%">Subject</th>
                    <th>Date</th>
                    <th>Lecture Type</th>
                    <th>Status </th>
                    <th>Remarks</th>
                    <!--<th style="width: 10px">Action</th>-->
                  </tr>
                </thead>
                <tbody>

                  <tr v-for="(result, ind) in getList()">
                    <td style="width: 10px" align="center">{{ind + 1}}</td>
                    <td>{{result.CourseTitle}} - {{result.ClassName}}</td>
                    <td>{{result.Date}}</td>
                    <td>{{result.LectureType}}</td>
                    <td align="center">
                      <b class="text-success" v-if="result.Present">Present</b>
                      <b class="text-warning" v-else-if="result.OnLeave">On Leave</b>
                      <b class="text-danger" v-else>Absent</b>
                    </td>
                    <td>{{result.Remarks}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>



<script>
  import axios from 'axios';
  export default {
    name: 'attendance',
    data() {
      return {
        attendance: [],
        courses: [],
        teacherID: 0,
        status: true,

      }
    },
    created() {
      this.pageLoad();
    },
    updated() {
      $('#tbl').DataTable();
    },
    methods: {

      //show up list of data form in table from database
      pageLoad() {
        //var url = new URLSearchParams(window.location.search);
        //var id = url.get("teacherID")

        var vm = this;
        axios.post('/api/PortalApi/getAttendance')
          .then(function (res) {
            vm.courses = res.data.courses;
            vm.attendance = res.data.results;
          });
      },

      Print() {
        var url = new URLSearchParams(window.location.search);
        var id = url.get("teacherID")
        window.location.href = "/Portal/AttendancePrint?teacherID=" + id;
      },

      getList() {
        var table = $('#tbl').DataTable();
        table.destroy();
        if (this.teacherID == 0)
          return this.attendance;
        else
          return this.attendance.filter((x) => { return x.TeacherCourseAllotmentID == this.teacherID });
      }
    }
  }</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/school/attendance/lectureAttendance.vue